import { Text } from '@savvy-kit/foundations/text';

type Props = {
  readonly icon: React.ReactElement;
  readonly title: string | null | undefined;
  readonly subtitle: string | null;
};
export default function PortfolioItemDescriptionRow({ icon, title, subtitle }: Props) {
  return (
    <div className="flex items-center">
      <div className="flex flex-row items-end pr-4">{icon}</div>
      <div className="flex flex-col gap-0">
        <Text color="dark">{title}</Text>
        <Text color="secondary" variant="body-sm">
          {subtitle}
        </Text>
      </div>
    </div>
  );
}
